/**
 * Importa os componentes necessarios do Material UI
 * - Tabs: Componente contenedor para multiplas abas
 * - Tab: Componente individual para cada aba
 */
import { Tabs, Tab } from '@mui/material';

/**
 * Componente TabsContainer
 * Um componente reutilizavel para criar navegacao por abas usando Material UI
 */
export default function TabsContainer({ tabIndex, onTabChange, tabLabels, marginB = { xs: 1, md: 1.5 }}) {
  return (
    <Tabs
      value={tabIndex}
      onChange={onTabChange}
      indicatorColor="primary"
      textColor="primary"
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile
      sx={{ mt: 0, mb: marginB}}
    >
      {tabLabels.map((label, index) => (
        <Tab
          key={index}
          label={label}
        />
      ))}
    </Tabs>
  );
}
